import { Button } from "@dspworkplace/ui";
import styled from "styled-components";

export const ReminderTitle = styled.div`
    color: #516F90;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
`;

export const ReminderDescription = styled.div`
    color: #707070;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
`;

export const FieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const DropdownWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    line-height: 16px;

    input {
        height: 36px;
        border-radius: 4px;
    }
`;

export const CustomLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
    color: #516f90;
    font-size: 14px;
    font-weight: 500;

    svg {
        padding-top: 3.5px;
    }
`;

export const MessagePreviewWrapper = styled.div`
    background: #eef4f8;
    border: 1px dashed #d7e1ea;
    border-radius: 4px;
    padding: 12px 16px;
`;

export const PreviewTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    margin-bottom: 4px;
`;

export const PreviewText = styled.div`
    font-size: 14px;
    color: #707070;
    line-height: 1.5;
    white-space: pre-wrap;
`;

export const DeliveryMethodWrapper = styled("div")`
    display: flex;
    gap: 8px;

    button {
        min-width: 70px;
        height: 32px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        background: #fff;
        color: #707070;
        cursor: pointer;
    }

    button.active {
        background: #0071BC;
        color: #fff;
        border-color: #0071BC;
    }

    button.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const PunchForm = styled.form`
    color: #707070;
`;

export const WarningWrapper = styled.div`
    display: flex;
    align-items: center;
    color: #d97706;
    gap: 12px;
    border: 1px solid #f0b96a;
    background-color: #fff8f0;
    border-radius: 6px;
    padding: 10px;

    div {
        display: inline-flex;
    }

`;

export const TabWrapper = styled.div`
    position: relative;
`;

export const EditButton = styled(Button)`
    padding: 4px;
    height: max-content;
    display: inline-flex;
    align-items: center;
    background: transparent;
    border-radius: 4px;

    &:hover,
    &:focus {
        color: #45556c;
        background: #CBD6E2;
        box-shadow: none;
    }

`

export const EditorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    button {
        width: max-content;
        align-self: flex-end;
    }

`

export const SpanTag = styled.span`
    font-size: 12px;
    font-weight: normal;
    font-family: Circe-Rounded;
    display: block;
    color: rgb(81, 111, 144);
    margin-top: 4px;
`;

export const Description = styled.div`
    border: 1px gray dashed;
    padding-left: 10px;
    padding-bottom: 5px;
`;

export const TextArea = styled.textarea`
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 4px;

    &:hover, &:focus {
        border: 1px solid #d1d5db;
        border-radius: 4px;
    }

`
